import CloseConversation from 'actions/conversation/close_conversation';
import CloseConversationWarning from 'models/modal/close_conversation_warning';
import Conversation from 'models/conversation';
import { hasActivePhoneCall } from 'scripts/application/lib/conversation_history_helpers';

import OpenModal from 'actions/modal/open_modal';

export default class TryClosingConversation {
  constructor(context) {
    this.context = context;
  }

  run({ conversationId, customerId }) {
    const { conversations, conversationHistory } = this.context.stores.customers.storesFor(customerId);

    const conversation = conversations.find(conversationId);
    const hasSla = conversation.hasSla();
    const conversationIsClosed = conversation.status === Conversation.Status.CLOSED;
    const hasActiveCall = hasActivePhoneCall({ conversationHistory, conversationId });

    const areTopicsRequired = this.context.stores.conversationWorkflowConfig.get().requireTopics;
    const conversationNeedsTopics = areTopicsRequired && !conversation.topicIds.length;

    if (conversationIsClosed || hasActiveCall || conversationNeedsTopics) {
      return;
    }

    hasSla
      ? this.context.executeAction(OpenModal, CloseConversationWarning.create({ conversationId, customerId }))
      : this.context.executeAction(CloseConversation, { conversationId, customerId });
  }
}
